/* tslint:disable */
/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AlertApiConfiguration, AlertApiConfigurationParams } from './alert-api-configuration';

import { AlertListService } from './services/alert-list.service';
import { DisasterListService } from './services/disaster-list.service';
import { MetaService } from './services/meta.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
   imports: [],
   exports: [],
   declarations: [],
   providers: [DisasterListService, AlertListService, MetaService, AlertApiConfiguration]
})
export class AlertApiModule {
   static forRoot(params: AlertApiConfigurationParams): ModuleWithProviders<AlertApiModule> {
      return {
         ngModule: AlertApiModule,
         providers: [
            {
               provide: AlertApiConfiguration,
               useValue: params
            }
         ]
      };
   }

   constructor(@Optional() @SkipSelf() parentModule: AlertApiModule, @Optional() http: HttpClient) {
      if (parentModule) {
         throw new Error('AlertApiModule is already loaded. Import in your base AppModule only.');
      }
      if (!http) {
         throw new Error(
            'You need to import the HttpClientModule in your AppModule! \n' +
               'See also https://github.com/angular/angular/issues/20575'
         );
      }
   }
}
